<template>
    <div>
        <div v-show="!isDetails">
            <div class="store_page">
                <div class="page_padding" v-infinite-scroll="load" style="overflow-y:auto;overflow-x:hidden">
                    <!--抬頭搜尋-->
                    <div class="page_top position-sticky top-0 w-100" style="z-index: 1">
                        <div class="title">
                            <i class="icon" @click="goHome()"></i>
                            <span style=" white-space:nowrap;" class="me-2 ">商城</span>
                            <el-input v-model="searchData.search" placeholder="輸入您想找的商品">
                            </el-input>
                            <el-button icon="el-icon-search" circle type="info" class="ms-2"
                                       @click="searchProduct()"></el-button>
                        </div>
                        <el-breadcrumb separator-class="el-icon-arrow-right" class="p-1 bg-white">
                            <el-breadcrumb-item v-for="i in categoryBreadcrumbs" :key="i.id">
                                <span @click="imgCategoryHandle(i.id)" style="font-size: 1.2rem">{{i.name}}</span>
                            </el-breadcrumb-item>
                        </el-breadcrumb>
                    </div>
                    <!--優惠活動-->
                    <div>
                        <!--手機尺寸-->
                        <el-carousel style="z-index: 0" height="150px" class="d-sm-none" v-if="promotions.length >0">
                            <el-carousel-item v-for="promotion in promotions" :key="promotion.id">
                                <img :src="promotion.img" alt="" class="w-100 h-100"
                                     @click="goToDetail(promotion.productId)">
                            </el-carousel-item>
                        </el-carousel>
                        <!--平板尺寸-->
                        <el-carousel style="z-index: -1" height="300px" class="d-none d-sm-block" v-if="promotions.length >0">
                            <el-carousel-item v-for="promotion in promotions" :key="promotion.id">
                                <img :src="promotion.img" alt="" class="w-100 h-100"
                                     @click="goToDetail(promotion.productId)">
                            </el-carousel-item>
                        </el-carousel>
                    </div>
                    <!--熱銷分類-->
                    <div class="category mt-2 bg-white m-2 br rounded shadow"
                         v-if="showHotCategory && category.length>0">
                        <div class="row col-12 mt-2">
                            <div class=" fs-2 mt-2">
                                <i class="fas fa-fire-alt mx-1" style="color: red"></i>
                                <span class="fw-bold">熱銷分類</span>
                            </div>
                        </div>
                        <div class="row py-2">
                            <div class="col-4" v-for=" i in category" :key="i.id">
                                <div class="d-flex justify-content-center align-items-center p-1 flex-column"
                                     @click="imgCategoryHandle(i.id)">
                                    <img :src='i.img' alt="" style="object-fit: cover;" class="w-100" @error="imgError" v-if="searchData.categoryId==1">
                                    <span class="mt-2 fw-bold">{{ i.name }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--商品列表-->
                    <div class="list mx-1">
                        <div class="row mx-1 mt-3">
                            <el-empty description="無商品相關資料" v-if="productseEmpty"></el-empty>
                            <div v-for="i in products" :key="i.id" class="col-6 mb-1 p-1">
                                <div class="w-100 rounded">
                                    <div class="d-flex justify-content-center flex-column bg-white rounded shadow"
                                         @click="goToDetail(i.id)">
                                        <img :src="JSON.parse(i.imgsUrl)[0]" alt="" class=" rounded-top w-100"
                                             @error="imgError">
                                        <div class="description-block px-2 mb-2">
                                            <div class="mt-1 d-flex align-items-center justify-content-between mb-1">
                                                <el-tag type="danger" effect="dark" v-if="i.isPreorder==1" size="mini">
                                                    預購
                                                </el-tag>
                                                <el-tag type="info" effect="dark" v-if="i.isPreorder==0" size="mini">
                                                    現貨
                                                </el-tag>
                                                <span class="fw-bold  text-secondary" style="font-size: 0.8rem"
                                                      v-if="i.shipDate > 0">保證{{ i.shipDate }}日內出貨</span>
                                            </div>
                                            <span class="title fw-bold"> {{ i.name }}</span>
                                            <div class="d-flex justify-content-between mt-3">
                                                <span
                                                    class="selling-price fw-bold"> {{
                                                        i.originalPrice.toLocaleString()
                                                    }}</span>
                                                <span
                                                    class="price fw-bold fs-3"> {{
                                                        i.salePrice.toLocaleString()
                                                    }}</span>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="w-100 d-flex justify-content-center my-2" v-if="!listLoad">
                        <el-button type="info" plain @click="loadBtn()">更多商品</el-button>
                    </div>

                    <div class="w-100 d-flex justify-content-center my-2" v-if="listLoad">
                        <i class="el-icon-loading fs-3"></i>
                    </div>

                </div>
            </div>
            <!--回到頂端-->
            <el-backtop target=".page_padding" :visibility-height="500" :bottom="150" :right="25"/>
            <!--底層菜單-->
            <!--            <MENU v-if="!this.$store.state.shoppingCarDrawer" :message="this.$root.shoppingCarCount"/>-->
            <MENU ref="storeMenu"></MENU>
        </div>
        <template v-if="isDetails">
            <router-view/>
        </template>
    </div>

</template>
<style>
.el-tabs__header {
    margin: 0;
}

.el-tabs {
    padding-left: 5px;
    padding-right: 5px;
}


</style>

<script>
import MENU from '@/components/storeMenu.vue'
import FN from '@/components/fn'
import SA from '@/components/store/shoppingAction.vue'

export default {
    components: {
        SA,
        MENU,
    },
    mixins: [FN],
    data() {
        return {
            count: 10,
            input: '',
            category: [],
            products: [],
            searchData: {
                page: 1,
                search: '',
                categoryId: 1,
                limit: 15,
            },
            showHotCategory: true,
            productIds: [],
            totalPage: 0,
            listLoad: false,
            productseEmpty: false,
            promotions: [],
            categoryBreadcrumbs: [],
        }
    },
    mounted() {
        this.getＨotCategory();
        this.getCategoryBreadcrumbs();
        this.getProducts();
        this.getStorePromotion();
    },
    methods: {
        goToDetail(id) {
            this.$router.push({name: 'StoreDetails', params: {id: id}})
        },
        addCar() {
            this.$store.commit('setShoppingCarDrawer', true);
        },
        // 分類頁籤點擊處理
        tabCategoryHandleClick(tab) {
            var categoryId = tab.name.split("_")[1];
            this.clearSearch();
            this.searchData.categoryId = categoryId;
            this.checkShowHotCategory();
            this.getProducts();

        },
        // 圖片分類點擊處理
        imgCategoryHandle(categoryId) {
            this.clearSearch();
            this.searchData.categoryId = categoryId;
            this.getProducts();
            this.getCategoryBreadcrumbs();
            this.getＨotCategory();
            console.log(123);
        },
        //搜尋商品
        searchProduct() {
            this.showHotCategory = false;
            var tmpSearch = this.searchData.search;
            this.clearSearch();
            this.searchData.search = tmpSearch;
            this.getProducts();
        },
        clearSearch() {
            this.searchData.page = 1;
            this.searchData.search = "";
            this.searchData.categoryId = 1;
            this.searchData.limit = 15;
            this.productIds = [];
            this.products = [];
            this.totalPage = 0;
        },
        // 取得商品
        getProducts() {
            this.listLoad = true;
            this.FETCH({
                key: 'GET_PORDUCTS',
                ...this.searchData,
            }).then((res) => {
                //需要accToken的驗證
                if (+(res || {}).code === -3) {
                    this.checkNewToken(this.handleSubmit)
                } else if (+(res || {}).code === 0) {
                    this.totalPage = res.pagination.last_page;

                    // 檢查是否無商品
                    this.checkProductseEmpty(res.pagination.total);
                    var data = res.pagination.data
                    var i = 0;
                    for (i; i < data.length; i++) {
                        var item = data[i];
                        if (!this.productIds.includes(item.id)) {
                            this.products.push(item);
                            this.productIds.push(item.id);
                        }
                    }
                } else {
                    this.$message('無法取得商品資訊，請稍後重試');
                }
                this.listLoad = false;
            })
        },
        load() {
            if (this.searchData.page < this.totalPage) {
                this.searchData.page += 1;
                this.getProducts();
            }

        },
        imgError(event) {
            event.target.src = require('@/assets/img_error.svg');
        },
        checkProductseEmpty(total) {
            if (total < 1) {
                this.productseEmpty = true;
            } else {
                this.productseEmpty = false;
            }
        },
        checkShowHotCategory() {
            if (this.searchData.categoryId == 1) {
                this.showHotCategory = true;
            } else {
                this.showHotCategory = false;
            }
        },
        getStorePromotion() {
            this.listLoad = true;
            this.FETCH({
                key: 'STORE_PROMOTION',
            }).then((res) => {
                //需要accToken的驗證
                if (+(res || {}).code === -3) {
                    this.checkNewToken(this.handleSubmit)
                } else if (+(res || {}).code === 0) {
                    this.promotions = res.data;
                } else {
                    this.$message('取得優惠資訊失敗，請稍後重試。')
                }
                this.listLoad = false;
            })
        },
        loadBtn() {
            if (this.searchData.page < this.totalPage) {
                this.searchData.page += 1;
                this.getProducts();
            }else{
                this.$message('沒有新資料');
            }
        },
        // 取得商品分類麵包屑
        getCategoryBreadcrumbs() {
            this.FETCH({
                key: 'GET_STORE_CATEGORY_BREADCRUMBS',
                id:this.searchData.categoryId

            }).then((res) => {
                //需要accToken的驗證
                if (+(res || {}).code === -3) {
                    this.checkNewToken(this.handleSubmit)
                } else if (+(res || {}).code === 0) {
                    this.categoryBreadcrumbs = res.data;
                } else {
                    this.$message('無法取得分類麵包屑，請稍後重試');
                }
            })
        },
        // 取得商品分類麵包屑
        getＨotCategory() {
            this.FETCH({
                key: 'GET_STORE_HOT_CATEGORY',
                id:this.searchData.categoryId

            }).then((res) => {
                //需要accToken的驗證
                if (+(res || {}).code === -3) {
                    this.checkNewToken(this.handleSubmit)
                } else if (+(res || {}).code === 0) {
                    this.category = res.data;
                } else {
                    this.$message('無法取得分類麵包屑，請稍後重試');
                }
            })
        },

    },
    computed: {
        isDetails() {
            const details = this.$route.name !== 'Store'
            return details
        },

    },
    beforeRouteUpdate(to, from, next) {
        const storeMenuInstance = this.$refs.storeMenu;
            storeMenuInstance.getChatroomNotReadTotal();
            storeMenuInstance.getShoppingCarCount();
        next();
    },
    showLoadButton(){
        if (this.searchData.page < this.totalPage && !this.listLoad) {
            this.showLoadButton = true;
        }

        this.showLoadButton = false;
    }

}
</script>





